var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "content d-inline",
      class: { highlight: _vm.highlight },
      style: { background: _vm.color }
    },
    [
      _vm.iconLeft
        ? _c("em", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasIcon,
                expression: "hasIcon"
              }
            ],
            staticClass: "far fa-times-circle pointer icon-left",
            on: { click: _vm.clickHandler }
          })
        : _vm._e(),
      _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm.hasIcon
        ? _c("em", {
            staticClass: "far fa-times-circle pointer icon-right",
            on: { click: _vm.clickHandler }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }